import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3","key":"svg-0"}],["path",{"d":"M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3","key":"svg-1"}]]

/**
 * IconRepeat
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcmVwZWF0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDEydi0zYTMgMyAwIDAgMSAzIC0zaDEzbS0zIC0zbDMgM2wtMyAzIiAvPgogIDxwYXRoIGQ9Ik0yMCAxMnYzYTMgMyAwIDAgMSAtMyAzaC0xM20zIDNsLTMgLTNsMyAtMyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/repeat
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconRepeat = createReactComponent('outline', 'repeat', 'Repeat', __iconNode);

export default IconRepeat;